import React, { Component } from 'react'

export default class AccessGridFilterCustomerItem extends Component {

    render() {
        return (
            <div className="filterItem" style={{marginTop: 4, marginBottom: 4, cursor: 'pointer',}} onClick={() => {
                this.props.onFilter(this.props.userName, this.props.login);
            }}>
                <div  style={{
                    fontSize: 14,
                    fontWeight: 'bold',
                    paddingLeft: 5,
                    display: 'inline'}}>
                    {this.props.userName}{this.props.login ? ' (' + this.props.login + ')' : false}
                    </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/AccessGridFilterCustomerItem.js